import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { FieldMessage, FieldMessageType } from '@components/form/field';
import {
  getFormFieldStylesAsClassName,
  getFormFieldMessageStylesAsClassName,
} from './form-field-styles';
import { twMerge } from 'tailwind-merge';

export type FormFieldProps = WithChildrenCommonProps<{
  /** Field Message type and content*/
  message?: {
    type: FieldMessageType;
    content: React.ReactNode;
  };
}>;

export const FormField = React.forwardRef(
  (
    props: FormFieldProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const { message, children, className: classNameProp, ...rest } = props;
    const twClassName = twMerge(
      getFormFieldStylesAsClassName(message?.content),
      classNameProp
    );
    return (
      <div className={twClassName} ref={ref} {...rest}>
        {children}

        {message && (
          <FieldMessage
            type={message.type}
            className={getFormFieldMessageStylesAsClassName(message?.content)}
          >
            {message.content}
          </FieldMessage>
        )}
      </div>
    );
  }
);

FormField.displayName = 'FormField';
